import { MatchingPermission } from '@adornis/bh-matching-user/permissions.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import { stateful, useObservable } from '@adornis/functional-lit/stateful.js';
import { permissionGuard } from '@adornis/user-forms/permission-guard.js';
import { html } from 'lit';
import { updateMentorVisibility } from '../../api/user.js';
import type { MentoringMentor } from '../../entities/mentoring-user.js';

export const mentorVisibilityToggle = stateful<{ mentor: MentoringMentor; translate }>(({ mentor, translate }) => {
  const theme = useObservable(() => DesignSystem.currentTheme, [1]);

  const isHidden = mentor.hiddenFromMentees;

  return permissionGuard(
    MatchingPermission.VIEW_ADMIN_DASHBOARD,
    () => html`
      <tr-button-small
        icon=${isHidden ? 'visibility' : 'visibility_off'}
        mode=${'outline'}
        ${css({ width: 'min-content' })}
        .color=${theme?.colors.tone.onyx}
        .action=${async (e: Event) => {
          e.stopPropagation();
          try {
            const success = await updateMentorVisibility(mentor._id, !isHidden)();
            if (!success) {
              XSnackbar.show(translate('mentor_visibility', 'error_saving'));
              return;
            }
            XSnackbar.show(
              isHidden ? translate('mentor_visibility', 'now_visible') : translate('mentor_visibility', 'now_hidden'),
            );
          } catch (err) {
            console.error(err);
            XSnackbar.show(translate('mentor_visibility', 'error_saving'));
          }
        }}
      >
        <tr-tooltip
          .text=${html`
            <x-text>
              ${isHidden ? translate('mentor_visibility', 'is_hidden') : translate('mentor_visibility', 'is_visible')}
            </x-text>
          `}
        >
        </tr-tooltip>
      </tr-button-small>
    `,
  );
});
